import { useMutation } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi';
import { IBankTransactionImportResponse } from '../types';

/**
 * React Query mutation hook for importing bank transactions via CSV file.
 *
 * This is a synchronous import - no polling needed.
 * The API either returns success with all rows imported,
 * or FAILED status with rowErrors detailing which rows had issues.
 *
 * @returns Mutation object for bank transaction import
 */
export const useBankTransactionImportMutation = () => {
  return useMutation<IBankTransactionImportResponse, Error, File>({
    mutationFn: async (file: File) => {
      const api = makeBookingManagerApi();
      const response = await api.importBankTransactions(file);
      return response.data;
    },
  });
};
